import React, { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/contexts/LanguageContext";
import { Layout } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import CollectionsPage from "@/pages/CollectionsPage";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import MaterialsPage from "@/pages/MaterialsPage";
import SavoirFairePage from "@/pages/SavoirFairePage";
import ProsPage from "@/pages/ProsPage";
import ContactPage from "@/pages/ContactPage";
import AppointmentPage from "@/pages/AppointmentPage";
import LegalPage from "@/pages/LegalPage";

function App() {
  useEffect(() => {
    document.documentElement.classList.add("dark");
    document.title = "ARVÈN Cuisines — L'art de concevoir votre quotidien";
  }, []);
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/collections" element={<CollectionsPage />} />
            <Route path="/projets" element={<ProjectsPage />} />
            <Route path="/projets/:slug" element={<ProjectDetailPage />} />
            <Route path="/materiaux" element={<MaterialsPage />} />
            <Route path="/savoir-faire" element={<SavoirFairePage />} />
            <Route path="/professionnels" element={<ProsPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/rendez-vous" element={<AppointmentPage />} />
            <Route path="/mentions-legales" element={<LegalPage />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
